"use client";

import { useEffect, useRef, Suspense } from "react";
import Script from "next/script";
import { usePathname } from "next/navigation";
import { initAckoAnalytics } from "@acko-tech/building-blocks.ui.acko-analytics";
import { useEnvVariablesClientConfig } from "@context/EnvVariablesClientContext";
import { getConfig } from "@configs/envConfig";
import { getTrackerId } from "@utils/utils";

export const InitialiseAckoAnalyticsImpl = () => {
  const config = useEnvVariablesClientConfig();
  const currentEnv = config?.ACKO_ENV;
  const SEGMENT_WRITE_KEY = getConfig(currentEnv)?.segmentKey;
  const trackerIdVal = getTrackerId();

  const pathname = usePathname();
  const previousPathRef = useRef<string | null>(null);

  const isLoginPage = (url: string): boolean => {
    const loginPatterns = ["/auth", "accounts.acko.com"];
    return loginPatterns.some((pattern) => url.includes(pattern));
  };

  const setPageReferrer = (url: string) => {
    if (typeof window !== "undefined") {
      const fullUrl = window.location.origin + url;
      if (!isLoginPage(fullUrl)) {
        sessionStorage.setItem("pageReferrer", fullUrl);
      }
    }
  };

  useEffect(() => {
    previousPathRef.current = pathname;

    const handleBeforeUnload = () => {
      setPageReferrer(window.location.pathname);
    };

    const handlePopState = () => {
      setPageReferrer(window.location.pathname);
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);

  useEffect(() => {
    if (previousPathRef.current && previousPathRef.current !== pathname) {
      setPageReferrer(previousPathRef.current);
    }

    previousPathRef.current = pathname;
  }, [pathname]);

  return (
    <div>
      {trackerIdVal && currentEnv && SEGMENT_WRITE_KEY ? (
        <Script
          async
          id="my-script"
          type="text/javascript"
          dangerouslySetInnerHTML={{
            __html: initAckoAnalytics(
              trackerIdVal || "",
              SEGMENT_WRITE_KEY || "",
              undefined
            ),
          }}
        />
      ) : null}
    </div>
  );
};

export const InitialiseAckoAnalytics = (props: any) => (
  <Suspense>
    <InitialiseAckoAnalyticsImpl {...props} />
  </Suspense>
);
